import {javaApiFor} from './api';
import FilterWordsProfile from 'records/FilterWordsProfile';
import {List} from 'immutable';

const filterWordProfilesApi = javaApiFor('/profile/filter_words/profiles');

export default {
  fetchAll() {
    return filterWordProfilesApi
      .getJson('/')
      .then(({profiles}) => List(profiles.map(profile => new FilterWordsProfile(profile))));
  },
};
